import { BORDER_STYLE_SECONDARY } from '@/features/mold/components';
import type { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const ReportTr: FC<Props> = ({ children }) => (
  <tr
    style={{
      border: BORDER_STYLE_SECONDARY,
      padding: 0,
    }}
  >
    {children}
  </tr>
);
